<div class="select-box">
    <!-- Proyección de contenido para el buscador -->
    <ng-content></ng-content>

    <div class="select-box__content" [style.max-height]="customHeight">
        <p *ngIf="!valuesList || valuesList.length === 0" [ngClass]="{}" class="font-body text-md select-item select-item-first select-item-last">
            {{ 'NO_DATA_FOUND' | translate }}
        </p>
        <div *ngFor="let value of valuesList; let index = index" [attr.gtm-label]="value.gtmLabel" (click)="onClick(value)">
            <p
                [ngClass]="{
                    'select-item-last': index === valuesList.length - 1,
                    'select-item-first': index === 0,
                    'font-body text-md select-item': true,
                    'select-item__small': small
                }"
            >
                {{ value.label | translate }}
            </p>
        </div>
    </div>
</div>
